<template>
  <div>
    <div v-bind:style="get_style()">

        <transition name="fade">
          <hit_survey_pass v-if="!pass" :survey="survey" :save="save" :callback="function(save){ pass = true; }" />
          <hit_survey_stars v-if="pass && error" :survey="survey" :save="save" :callback="function(save){ set_save(save); }" />
          <hit_survey_form  v-if="pass && !error" :survey="survey" :save="save" class="hit-col-md-12" />
        </transition>

        <transition name="fade">
          <div class="hit-col-md-12" v-if="!error" v-bind:key="'submitBtn'">
            <a class="hit-html-a" href="#" v-bind:style="{'color': survey.colors.accent_color}" v-on:click.prevent="function(){ error = !error; }">{{ $t("message.goTo", {name: $tc("message.board", 1)}) }}</a>
          </div>
        </transition>

        <div class="hit-clearfix"></div>

    </div>

  </div>

</template>

<script>

import form from '@core/components/survey/form.vue'
import stars from '@core/components/survey/style/default/stars.vue'
import pass from '@core/components/survey/pass.vue'

export default{

  props: { survey: Object},
  components: { hit_survey_form: form, hit_survey_stars: stars, hit_survey_pass: pass },

  data: function () {
    var pass = true

    if (this.survey.pass) { pass = false }

    return {error: true, save: {}, pass: pass}
  },

  methods: {

    set_save: function (save) {
      this.save = save
      this.error = false
    },
    get_style: function () {
      return {

        background: this.survey.colors.background_color,
        border: '1px solid ' + this.survey.colors.accent_color,

      }
    }
  }

}

</script>
